import { FC, useContext, useEffect } from "react";

import { TreatmentInstillationModalProps, TreatmentInstillationProps, } from "./types";
import useFetch from "src/hooks/useFetch";
import { TreatmentStatusUpdateApiResponse } from "src/pages/treatmentListing/types";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { TreatmentInstillationSchema } from "src/validation/treatmentInstillation";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import HubInputField from "src/components/inputType";
import { format } from "date-fns";

const TreatmentInstillationModal: FC<TreatmentInstillationModalProps> = ({ isModalVisible, patientName, hideModal,treatmentId,instillation,treatedAt,refreshListing}): JSX.Element => {
  const { control, handleSubmit,reset} = useForm<TreatmentInstillationProps>({
    mode: 'all',
    resolver: yupResolver(TreatmentInstillationSchema),
    defaultValues: {date: ""}
  });
  const {data:treatmentUpdateData,mutate: updatetreatment,  error:treatmentUpdateError } = useFetch<TreatmentStatusUpdateApiResponse>(APIEndpoints.TREATMENT_STATUS_UPDATE,  {} , { treatmentId})
  const { showToast } = useContext(ToastContext);
  const { hideLoader } = useContext(LoaderContext);
  const clickOntreatmentInstillation = (value:TreatmentInstillationProps) => {
    const requestBody = {
      "scheduled_at":  value.date
    }
    updatetreatment(requestBody)
  }

  useEffect(() => {
     if(instillation) reset({ date: `${format(instillation, "yyyy-MM-dd")}T${format(instillation, "HH:mm")}` });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instillation]);

  useEffect(() => {
    if (treatmentUpdateData || treatmentUpdateError) {
      hideLoader();
      reset()
      hideModal();
      if(treatmentUpdateData){
        showToast([`Treatments Instillation Updated Successfully.`], ToastTypes.SUCCESS);
        refreshListing();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatmentUpdateData, treatmentUpdateError]);

  const internalHideModal = () => {
    reset()
    hideModal()
  }
  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={internalHideModal}
    >
     <form onSubmit={handleSubmit(clickOntreatmentInstillation)}>

      <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">
              Schedule Treatment for {patientName}
            </h1>
            <button type="button" className="btn-close" aria-label="Close" onClick={hideModal}></button>
          </div>

          <div className="modal-body">
            <p className="text-center"> Please specify date of treatment... </p>
            <p className="text-center"> NOTE: The submitting office has requested an appointment for {treatedAt !==null ?  treatedAt : ""} </p>
            <div className="row align-items-center">
              <div className="col-3">
                <p className="mb-0 text-end"> Date and Time </p>
              </div>

              <div className="col-7">
                {/* <input type="datetime-local" name="treatmentDate" className="form-control" value ={date} onChange={onDateChange} /> */}
                <Controller
                    name="date"
                    control={control}
                    // defaultValue=""
                    render={({ field, fieldState: { error } }) => (
                      <HubInputField
                      isRowBased={true}
                      isRequired={false}
                      isRowInsideAnother={true}
                      inputId={`date`}
                      field={field}
                      error={error}
                      inputType="datetime-local"
                      />
                    )}
                  />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="submit" className="btn btn-primary" data-bs-dismiss="modal" >
              Save
            </button>
          </div>
        </div>
      </div>
      </form>
    </div>
  );
};

export default TreatmentInstillationModal;
